import { getApiInstance } from '../helpers';

const postUnlockFile = (ticketId, partId, password) => {
  return getApiInstance()
    .post('/ticket/decrypt-file', {
      ticketId,
      partId,
      password,
    })
    .then((res) => res.data);
};
export const unlockFileService = {
  postUnlockFile,
};
